{
  "bookmarkTitleLabel": "Marcadores",
  "debug": "Depurar",
  "devConnectionLabel": "Developer Connection",
  "exlSection": "Resultados de Experience League",
  "feedback": "Comentarios",
  "fetchFailed": "Se ha producido un error en la búsqueda.",
  "help": "Ayuda",
  "helpDefaultFeatured": "Aprendizaje y asistencia de Adobe Experience Cloud",
  "helpLoadError": "Se ha producido un error. Inténtelo de nuevo.",
  "noBookmarks": "Para acceder al contenido de ayuda aquí, márquelo como favorito",
  "noBookmarksTitle": "No hay marcadores",
  "noResults": "No hay resultados",
  "noResultsMessage": "Revise la ortografía o pruebe un término de búsqueda diferente",
  "resourcesCustomerCareLabel": "Servicio de atención al cliente",
  "resourcesStatusLabel": "Estado",
  "support": "Asistencia técnica"
}
